var generateStyle = function generateStyle(componentTheme) {
  return {
    choice: {
      display: 'flex',
      alignItems: 'center',
      padding: componentTheme.padding,
      border: "".concat(componentTheme.borderWidth, " solid ").concat(componentTheme.borderColor),
      borderRadius: componentTheme.borderRadius,
      backgroundColor: componentTheme.backgroundColor,
      choiceActions: {
        display: 'flex'
      },
      choiceBody: {
        paddingLeft: componentTheme.bodyPaddingLeft,
        paddingRight: componentTheme.bodyPaddingRight
      }
    },
    actionsContentIconWrapper: {
      display: 'flex',
      padding: "0 ".concat(componentTheme.actionIconPadding)
    }
  };
};
export default generateStyle;